import React from "react";
import { Result } from "antd";
import { useIsFeatureEnabled } from "../../hooks/useSystemFeatures";

/**
 * Wraps a subtree and renders its children only when the given system feature
 * is enabled for the current user. Fails open while the privilege query is
 * loading (see useIsFeatureEnabled) so slow networks don't flash the
 * disabled-feature screen.
 *
 * Not a security boundary — the backend must also enforce the flag.
 *
 * Usage:
 *   <FeatureGate featureKey="refund_voucher">
 *     <RefundVoucher />
 *   </FeatureGate>
 */
const FeatureGate = ({ featureKey, children, fallback }) => {
  const enabled = useIsFeatureEnabled(featureKey);
  if (enabled) return <>{children}</>;
  if (fallback !== undefined) return <>{fallback}</>;
  return (
    <Result
      status="403"
      title="Feature disabled"
      subTitle={`The "${featureKey}" feature is currently disabled. Contact a super administrator if you believe this is in error.`}
    />
  );
};

export default FeatureGate;
